import React from 'react';

const CoachDefault = () => (
  <h1>coach default</h1>
);

export default CoachDefault;
